export class OutOfOfficeBackup {
  outOfOfficeId: number;
  userId: string;
  backupUserId: string;
  backupType: string;
}
